<template>
  <v-autocomplete
    v-model="select"
    :items="vehicles"
    :filter="filter"
    item-value="vehicleId"
    :search-input.sync="search"
    :error-messages="errorMessages"
    flat
    :rounded="rounded"
    :label="$t('component.vehicle_field.title')"
    :disabled="disabled"
    :clearable="clearable"
  >
    <template v-slot:selection="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.numericPlate }} <span class="grey--text">{{ item.name }}</span></v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.numericPlate"></v-list-item-title>
        <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
/*
 * model input value format:
 *   vehicle object
 */
export default {
  name: "VehicleField",
  props: {
    value: {
      type: Object
    },
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      select: null,
      search: null
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.numericPlate.toLowerCase() + " " + item.name.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    setValue(value) {
      this.select = (value !== null) ? value.vehicleId : null;
    }
  },

  watch: {
    select: function() {
      this.$emit("input", this.vehicles.find(x => x.vehicleId === this.select) || null);
    },

    value:  function() {
      this.setValue(this.value);
    }
  },

  computed: {
    vehicles: function() {
      return this.$store.state.online.vehicles;
    }
  },

  mounted() {
    this.setValue(this.value);
  }
};
</script>

<style scoped>

</style>